import { dataSearchDesktopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSearchDesktopSolid = /*#__PURE__*/createIcon(dataSearchDesktopSolid)
export default IconSearchDesktopSolid
